import React from "react";
import ProductHeader from "../../Components/Product/ProductHeader/ProductHeader";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import FociiApplications from "../../Components/Product/FociiApplications/FociiApplications";
import Insights from "../../Components/Product/Insights/Insights";
import UserDesign from "../../Components/Product/UserDesign/UserDesign";
import Datamanagement from "../../Components/Product/Datamanagement/Datamanagement";
import Baai from "../../Components/Product/Baai/Baai";

const ProductPage = () => {
  return (
    <>
      <Header />
      <ProductHeader />
      <FociiApplications />
      <Insights />
      <Datamanagement />
      <UserDesign />
      <Baai />
      <Footer />
    </>
  );
};

export default ProductPage;
